import { Button, Col, DatePicker, Form, Input, Row, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import TimeLineStyle from "./style";
import {
  DownloadOutlined,
  SearchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import TabsList from "../../../Reusable/Tabs";
import { useNavigate, useParams } from "react-router-dom";
import TrainingStyle from "../TrainingMatrix/style";
import DashboardStyle from "../../Dashboard/style";

const TimelineReports = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm()
  const [activeTab, setActiveTab] = useState("1");

  const {tab} = useParams();

  console.log("tabs---->", tab)

  useEffect(() => {
    if (tab) {
      switch (tab) {
        case "timeline-reports":
          setActiveTab("3");
          break;
        case "training-matrix":
          setActiveTab("2");
          break;
        default:
          setActiveTab("1");
      }
    }
  }, [tab]);

  const TimelineData = [
    {
      timeline: "14 minutes ago",
      event: "You signed in",
    },
    {
      timeline: "19/10/2024",
      event: "You signed in",
    },
    {
      timeline: "18/10/2024",
      event: "You added yourself to the course New course via self enrollment",
    },
  ];

  const items = [
    {
      id: "1",
      label: "Overview",
      component: <></>,
    },
    {
      id: "2",
      label: "Training matrix",
      component: <></>,
    },
    {
      id: "3",
      label: "Timeline",
      component: <></>,
    },
  ];

  const dataSource = [
    {
      key: "1",
      user: "Guhan",
      courses: ["React", "JavaScript", "CSS"],
    },
    {
      key: "2",
      user: "Bharath",
      courses: ["Node.js", "MongoDB", "Express"],
    },
    {
      key: "3",
      user: "Shalini",
      courses: ["HTML", "CSS", "JavaScript"],
    },
  ];

  // Helper function to flatten data for the table
  const getTableData = () => {
    let tableData = [];
    dataSource.forEach((data, index) => {
      data.courses.forEach((course, courseIndex) => {
        tableData.push({
          key: `${data.key}-${courseIndex}`,
          user: data.user,
          course: course,
          userRowSpan: courseIndex === 0 ? data.courses.length : 0, // Only span on the first course
        });
      });
    });
    return tableData;
  };

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text, record) => ({
        children: text,
        props: {
          rowSpan: record.userRowSpan, // User spans across rows only once
        },
      }),
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
    },
  ];

  const OverviewData = [
    {
      label: "Active User",
      value: 1,
    },
    {
      label: "Never logged in",
      value: 0,
    },
    {
      label: "Assigned courses",
      value: "0",
    },
    {
      label: "Completed courses",
      value: "0",
    },
  ];
  const QuickActions = [
    {
      label: "Users reports",
      value: 1,
      icon: "people",
      path: "/users/adduser",
    },
    {
      label: "Course reports",
      value: "0h 00m",
      icon: "people",
      path: "/group",
    },
    {
      label: "Branch reports",
      value: "0.0%",
      icon: "people",
    },
    {
      label: "Group reports",
      value: "0.0%",
      icon: "people",
    },
    {
      label: "Learning activities reports",
      value: "0.0%",
      icon: "people",
    },
    {
      label: "Custom reports",
      value: "0.0%",
      icon: "people",
    },
  ];

  const handleTabSelect = (key) => {
    console.log("key-->", key);
    setActiveTab(key);
  };

  const hanldeClickPath = (path) => {
    console.log("path--->", path);
    navigate(path);
  };

  const onResetFunction = () => {

  }

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  const EventData = [
    {
      label: "Demo",
      value: "demo",
    },
  ];

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <TimeLineStyle>
        <TabsList
          items={items}
          handleTabSelect={handleTabSelect}
          tabId={activeTab}
          activeKey={activeTab}
        />
        {activeTab === "1" && (
          <>
            <DashboardStyle>
              <Row gutter={16}>
                <Col xl={12}>
                  <div className="overview-details-container">
                    <p className="details-box-title">Stats</p>
                    <div className="overview-details-box">
                      {OverviewData.map((item, index) => {
                        return (
                          <div key={index} className="overview-details">
                            <p className="overview-value">{item.value}</p>
                            <p className="overview-label">{item.label}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>
                <Col xl={12}>
                  <div className="overview-details-container">
                    <p className="details-box-title">Reports</p>
                    <div className="overview-details-box">
                      {QuickActions.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="quick-actions-details"
                            onClick={() => hanldeClickPath(item.path)}
                          >
                            <UserAddOutlined className="quick-actions-img" />
                            <p className="overview-label">{item.label}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>
              </Row>
            </DashboardStyle>
          </>
        )}

        {activeTab === "2" && (
          <>
            <TrainingStyle>
              <Row className="training-filter-container">
                <Col>
                  <Form.Item name="search" className="search-input-field">
                    <Input suffix={<SearchOutlined />} placeholder="Search" />
                  </Form.Item>
                </Col>
                <Col>
                  <Button className="export-reports-button">Export in Excel</Button>
                </Col>
              </Row>

              <br></br>

              <Table
                dataSource={getTableData()} // Use the flattened data
                columns={columns}
                pagination={false}
                bordered
              />
            </TrainingStyle>
          </>
        )}

        {activeTab === "3" && (
          <>
            <Row className="">
              <Form 
                layout="vertical" 
                form={form} 
                className="timeLine-filter-section"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                onReset={onResetFunction}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
              >
                <Col xl={7}>
                  <Form.Item
                    label="From"
                    name="fromDate"
                    className="timeline_filter_input_label"
                  >
                    <DatePicker
                      onChange={onChange}
                      className="timeline_filter_input"
                    />
                  </Form.Item>
                </Col>

                <Col xl={7}>
                  <Form.Item label="To" name="toDate" className="timeline_filter_input_label">
                    <DatePicker
                      onChange={onChange}
                      className="timeline_filter_input"
                    />
                  </Form.Item>
                </Col>

                <Col xl={7}>
                  <Form.Item
                    label="Event"
                    name="eventSelect"
                    className="timeline_filter_input_label"
                  >
                    <Select
                      className="timeline_filter_input"
                      options={EventData}
                    />
                  </Form.Item>
                </Col>

                <Col xl={7}>
                  <Form.Item
                    label="User"
                    name="userSelect"
                    className="timeline_filter_input_label"
                  >
                    <Select
                      className="timeline_filter_input"
                      options={EventData}
                    />
                  </Form.Item>
                </Col>

                <Col xl={7}>
                  <Form.Item
                    name="courseSelect"
                    label="Course"
                    className="timeline_filter_input_label"
                  >
                    <Select
                      className="timeline_filter_input"
                      options={EventData}
                    />
                  </Form.Item>
                </Col>
                <Button htmlType="reset" className="input_reset_button">Reset</Button>
              </Form>
            </Row>
            <br></br>
            <Row className="events_data_container">
              <div className="events_header_section">Event</div>
              <div className="events_data_box_container">
                {TimelineData.map((item, index) => {
                  return (
                    <div key={index} className="events_data_box">
                      <div className="event-backward-img-box">
                        <DownloadOutlined className="event-backward-img" />
                      </div>
                      <div>
                        <p className="creation-date">{item.timeline}</p>
                        <p className="event_name">{item.event}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Row>
          </>
        )}
      </TimeLineStyle>
    </>
  );
};

export default TimelineReports;
